
import {ACTIONS} from '../../actions/waitlist.actions';

const initialState = {
  fetchInProgress: false,
  fetchError: '',
  templates: [],
  welcomeTemplate: [],
  actionInProgress: '',
  actionError: ''
}

export default function waitlistReducer(state = initialState, action) {
  debugger;
  switch(action.type) {
    case ACTIONS.WaitlistTemplatesLoading: {
      return {...state, fetchInProgress: true, fetchError: '', templates: [] };
    }
    case ACTIONS.WaitlistTemplatesLoaded: {
      return {...state, fetchInProgress: false, fetchError: '', templates: action.payload.filter(t=>t.type !== 'welcome'), welcomeTemplate: action.payload.find(t=>t.type == 'welcome')};
    }
    case ACTIONS.WaitlistTemplatesError: {
      return {...state, fetchInProgress: false, fetchError: action.payload };
    }

    case ACTIONS.WaitlistTemplateAdding: 
    case ACTIONS.WaitlistTemplateDeleting: 
    case ACTIONS.WaitlistTemplateUpdating: {
      return {...state, actionInProgress: action.type, actionError: '' }
    }

    case ACTIONS.WaitlistTemplateAddFailed: 
    case ACTIONS.WaitlistTemplateDeleteFailed: 
    case ACTIONS.WaitlistTemplateUpdateFailed: {
      return {...state, actionInProgress: '', actionError: action.payload }
    }

    case ACTIONS.WaitlistTemplateAdded: {
      return {
        ...state, 
        actionInProgress: '', 
        templates:  [...state.templates, action.payload]
      }
    }

    case ACTIONS.WaitlistTemplateUpdated: {
      debugger;
      if (state.welcomeTemplate && state.welcomeTemplate._id === action.payload._id){
        return {
          ...state, 
          welcomeTemplate: action.payload
        };
      } else {
        let newArr = state.templates.map(t=> (t._id == action.payload._id) ? action.payload : t);
        return {
          ...state, 
          actionInProgress: '', 
          templates:  newArr
        }
      }
    }

    case ACTIONS.WaitlistTemplateDeleted: {
      const todel = state.templates.findIndex(t=>t._id === action.payload._id);
      let tmpArr = state.templates.slice();
      tmpArr.splice(todel,1);
      return {
        ...state, 
        actionInProgress: '', 
        templates:  tmpArr
      }
    }

    default: 
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/waitlist/index.js